export const state = {
  downloadProcess: [],
  percentageProcess: [0, 25, 50, 75, 90, 100],
  index: 0,
  failedDownload: [],
  isGraphOpen: true
}

export const getters = {
  showAll: (state) => state.downloadProcess,
  showProgress: (state) => {
    var percentageArr = state.downloadProcess.map(item => item.percentage);
    var sum = percentageArr.reduce((partialSum, a) => partialSum + a, 0);

    if (sum == 0 || percentageArr.length == 0) {
      return 0;
    }
    return sum / percentageArr.length;
  }
}

export const mutations = {
  saveProgress(state, payload) {
    state.downloadProcess.push(payload)
  },
  deleteProgress(state, payload) {
    var index = state.downloadProcess.indexOf(payload);
    if (index !== -1) {
      state.downloadProcess.splice(index, 1);
    }
  },
  updateProgress(state, payload) {
    var index = state.downloadProcess.indexOf(payload.progress);
    if (index !== -1) {
      state.downloadProcess[index].percentage = payload.percentage;
    }
  },
  removeAllProgress(state) {
    state.downloadProcess = [];
  },
  changeGraphStatus(state, payload) {
    state.isGraphOpen = !payload;
  }
}
